import React from 'react'
import { useSelector } from 'react-redux';

class Summary extends React.Component {
    render() {

        const { assessments } = this.props.security.security;

        const generateData = () => {
            const processedSummary = { "languages": {} };
            for (const { language, reports } of assessments) {
                processedSummary.languages[language] = { "empty": true, "issues": [] }
                for (const report of reports) {
                    processedSummary.languages[language].empty = false
                    processedSummary.languages[language].issues.push({
                        name: report.dependency.library.displayName,
                        version: report.dependency.version,
                        threat: report.advices[0].severity,
                        hasSafeVersion: report.safeVersions ? !!report.safeVersions.latestPatch || !!report.safeVersions.latestMinor || !!report.safeVersions.latestMajor : null,
                        excluded: report.advices[0].exclusions && report.advices[0].exclusions.length
                    })
                }
            }


            return processedSummary


        }

        const sort = () => {
            for (const language in processed.languages) {
                processed.languages[language].issues.sort((a, b) => {
                    if (b.threat === "CRITICAL") return 1;
                    if (a.threat === "CRITICAL") return -1;
                    if (b.threat === "HIGH") return 1;
                    if (a.threat === "HIGH") return -1;
                    if (b.threat === "MEDIUM") return 1;
                    if (a.threat === "MEDIUM") return -1;
                    if (b.threat === "LOW") return 1;
                    if (a.threat === "LOW") return -1;
                    if (b.threat === "SUGGEST") return 1;
                    if (a.threat === "SUGGEST") return -1;
                    if (b.threat === "NONE") return 1;
                    if (a.threat === "NONE") return -1;
                    return -1
                })
            }
        }

        const clickThrough = () => {
            this.props.collapse(true)
        }
        const LanguageEntries = ({ entry }) => {
            let suggest = 0;
            let none = 0;
            let excluded = 0
            let rows = entry.map(component => {
                if (component.excluded){
                    excluded++
                    return null
                }
                if (component.threat === "SUGGEST") {
                    suggest++
                    return null
                }
                if (component.threat === "NONE") {
                    none++
                    return null
                }
                if (component.threat === "TRUSTED") return null

                return (
                    <tr key={component.name + component.version + "security-summary"}>
                        <td><a href={"#advice-" + component.name + component.version} onClick={clickThrough}>{component.name}</a></td>
                        <td >{component.version}</td>
                        <td className={"level-" + component.threat.toLowerCase() + " text-center"}><b>{component.threat}</b></td>
                        <td className="text-center">{component.hasSafeVersion === null ? "--" : (component.hasSafeVersion ? <i className="fas fa-check" style={{ color: "green" }}></i> : "")}</td>
                    </tr>
                )
            })
            if (suggest + none + excluded > 0) {
                rows.push(
                    <tr key={"suggestions+none+security-summary"}>
                        <td colSpan={4}>
                            Suggestions: {suggest} <span className='mr-4 ml-4'>&nbsp;</span>
                            Informational: {none} <span className='mr-4 ml-4'>&nbsp;</span>
                            Exclusions: {excluded} 
                        </td>
                    </tr>
                )
            }
            return rows
        }



        const SummaryTable = ({ processed }) => {
            const languages = Object.keys(processed.languages);
            const hiddenLanguages = useSelector((state) => state.languagesFilter.toggledLanguages)
            languages.sort((a, b) => {
                if (processed.languages[a].empty) return -1
                if (processed.languages[b].empty) return -1
                return 0
            })

            return languages.map((language) => {
                const currentLanguage = processed.languages[language];
                if(hiddenLanguages.includes(language)) return
                return (
                    <div key={language + "-security-summary"} className="col-lg-12 mb-3">
                        <React.Fragment>

                            <p className="mt-2 mb-1"><b>{language}</b></p>
                            {currentLanguage.empty ?
                                <p className="w-100 text-center">No issues detected</p> :
                                <table className="summary-table table table-condensed ">
                                    <thead>
                                        <tr>
                                            <th width="55%">Name</th>
                                            <th width="15%">Version</th>
                                            <th width="15%" className="text-center">Threat level</th>
                                            <th width="15%" className="text-center">Safe update</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <LanguageEntries entry={currentLanguage.issues} />
                                    </tbody>
                                </table>
                            }
                        </React.Fragment>
                    </div>
                )
            })
        }

        const processed = generateData();
        sort();

        return (

            <div className="col-md-12" id="dependency-summary">
                <div className="container-fluid " >
                    <div className="report-box-body row justify-content-center">
                        <SummaryTable processed={processed} />
                    </div>
                </div>
            </div>
        )
    }
}


export default Summary